<template>
  <hi-page-column card grow>
    <transition name="fade">
      <div class="pa-8 ui-text" style="overflow: auto">
        Querying the database...
        <div v-for="item in log" :key="item" v-html="item"></div>
      </div>
    </transition>
  </hi-page-column>
</template>

<script>
// import { collections, db } from "@/db";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import { collections } from "@/db";

function preFormat(number) {
  return (
    number
      //delete all non-digit except for +
      .replace(/[^\d+]/g, "")
      //replace leading 00
      .replace(/^00/, "+")
      //support incomplete numbers for common mistakes for Australian numbers.
      .replace(/^61/, "+61")
      .replace(/^\+6104/, "+614")
      //support for Chinese mainland as well.
      .replace(/^86/, "+86")
  );
}
export default {
  name: "MobileNumbersChecker",
  data() {
    return {
      log: [],
      init: true
    };
  },
  components: {
    HiPageColumn
  },
  methods: {
    async fixMobile(data) {
      const logPre = `${data.name} (${data.id}) - `;
      const toUpdate = {};
      if (data.mobile) {
        if (!/^(\+614)\d{8}$/.test(data.mobile)) {
          let log = `${logPre}Invalid mobile number "${data.mobile}. "`;
          let number = preFormat(data.mobile);
          if (/^(04|\+614)\d{8}$/.test(number)) {
            const mNumber = number.replace(/^04/, "+614");
            log += `Has been fixed to "${mNumber}"`;
            this.logMsg(log);
            toUpdate.mobile = mNumber;
          } else {
            log += " Unable to fix.";
            this.logErr(log);
          }
        }
      }
      if (data.phone) {
        const number = preFormat(data.phone);

        if (/^(04|\+614)\d{8}$/.test(number)) {
          const mNumber = number.replace(/^04/, "+614");
          let log = `${logPre}phone number "${data.phone}" detected as mobile. Formatted to "${mNumber}". `;
          toUpdate.phone = null;
          if (data.mobile) {
            if (mNumber === data.mobile) {
              log += " Formatted value same as mobile number. Discarded.";
            } else {
              toUpdate.otherMobiles = [mNumber];
              log += " Added to 'otherMobiles'.";
            }
          } else {
            toUpdate.mobile = mNumber;
            log += " Added to 'mobile'.";
          }
          this.logMsg(log);
        }
      }
      if (Object.keys(toUpdate).length) {
        console.log(toUpdate);
        return await collections.leads.doc(data.id).update(toUpdate);
      }
      return true;
    },
    logErr(msg) {
      this.log.push(`<span class="log-error">${msg} </span>`);
    },
    logMsg(msg, sep) {
      if (sep)
        this.log.push(
          `<div style="border-bottom:1px solid #bbbbbb">${msg} </div>`
        );
      else this.log.push(`<div>${msg} </div>`);
    }
  },
  mounted() {
    collections.leads.get().then(async snapshot => {
      if (!snapshot.empty) {
        const docs = snapshot.docs;
        this.log.push("Getting " + docs.length + " leads from database.");
        for (let i = 0; i < docs.length; i++) {
          // console.log(docs[i].data());
          const doc = docs[i];
          const data = doc.data();
          data.id = doc.id;
          await this.fixMobile(data);
        }
      }
    });
  }
};
</script>

<style scoped>
::v-deep .log-error {
  background-color: #eab9b0;
  color: darkred;
}
::v-deep .log-info {
  background-color: #edead6;
  font-weight: bold;
  padding-left: 5px;
  padding-right: 5px;
}
::v-deep .log-result {
  background-color: #dff4d7;
  color: darkolivegreen;
  font-weight: bold;
  padding-left: 5px;
  padding-right: 5px;
}
</style>
